import React from 'react';
import {useDashboard} from "../../../utilities/context/dashboard/dashboard-context";
import {useNavigate} from "react-router-dom";
import Button from "../../UI/Button";
import History from "./History";
import SubscriptionDisplay from "./SubscriptionDisplay";

const Subscriptions = () => {

    const {subscription, history} = useDashboard();

    const navigate = useNavigate();

    const handleClick = () => {
        navigate("upgrade");
    }

    const handlePurchase = () => {
        navigate("subscriptions");
    }

    return (
        <div className="p-4">
            {subscription ?
                <div className="bg-ea_green_from p-2 text-left">
                        <SubscriptionDisplay onClick={handleClick}/>
                </div>
                : <div>Non risulta presente un abbonamento attivo</div>
            }
            <div className="flex flex-col md:flex-row gap-4 my-4 justify-center md:items-center">
                {subscription?.subscription?.type === "initial" &&
                <Button className="text-black" onClick={handleClick}>Acquista un pacchetto aggiuntivo</Button>}
                {subscription?.subscription?.type === "trial" &&
                <div className="text-ea_yellow">Il nuovo abbonamento partirà alla scadenza dell'attuale periodo di
                    prova</div>
                }
                {(!subscription || subscription.can_buy_more === true) &&
                <Button className="text-black" onClick={handlePurchase}>Acquista un nuovo abbonamento</Button>
                }

            </div>

            {history && <History/>}
        </div>
    );
};

export default Subscriptions;